export class BS4ModalNotifier {
    constructor(modalSelectorOrElement, options = { show: false }) {
        this.$modal = $(modalSelectorOrElement).modal(options);
    }
    setTitle(title) {
        this._setTitleHTML(title);
    }
    clear() {
        this._setBodyHTML("");
    }
    display(message) {
        if (message) {
            this._setBodyHTML(message);
        }
        this.$modal.modal("show");
    }
    _setTitleHTML(html) {
        this.$modal.find(".modal-title").html(html);
    }
    _setBodyHTML(html) {
        this.$modal.find(".modal-body").html(html);
    }
}
//# sourceMappingURL=notifier.js.map